import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { runner } from '../../docs-routes'

const RunSelectedStepsTestStepsDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Displays the filtered test steps based on the selected filters on the left. Step statuses reflect the latest run of this test config. In addition to standard statuses, steps that have never run or were skipped will be indicated accordingly.
    </Color>
    <br />
    <br />
    <Paragraph>
      <LinkToDocusaurus path={runner}>Learn more in the DAI documentation</LinkToDocusaurus>
    </Paragraph>
  </Paragraph>

export default RunSelectedStepsTestStepsDescription
